import {
  newModal,
  closeModal,
  mergeModalState,
} from "@js/helpers/state.js";

import {
  CE_DISMISS_SAVE_CUSTOM_ROW_MODAL,
  CE_OPEN_SAVE_CUSTOM_ROW_MODAL,
  CE_SAVE_CUSTOM_ROW_STARTED,
  CE_SAVE_CUSTOM_ROW_FAILURE,
  CE_SAVE_CUSTOM_ROW_SUCCESS,
  CE_SAVE_CUSTOM_ROW_ABORTED,
  CE_MANAGE_CUSTOM_ROWS_LOAD_STARTED,
  CE_MANAGE_CUSTOM_ROWS_LOAD_SUCCESS,
  CE_MANAGE_CUSTOM_ROWS_LOAD_FAILURE,
  CE_MANAGE_CUSTOM_ROWS_LOAD_ABORTED,
  CE_DELETE_CUSTOM_ROW_REQUEST,
  CE_DELETE_CUSTOM_ROW_STARTED,
  CE_DELETE_CUSTOM_ROW_SUCCESS,
  CE_DELETE_CUSTOM_ROW_FAILURE,
  CE_DELETE_CUSTOM_ROW_ABORTED,
  CE_RENAME_CUSTOM_ROW_REQUEST,
  CE_RENAME_CUSTOM_ROW_STARTED,
  CE_RENAME_CUSTOM_ROW_SUCCESS,
  CE_RENAME_CUSTOM_ROW_FAILURE,
  CE_RENAME_CUSTOM_ROW_ABORTED,
} from "@js/actions/studio/campaign_content_section/custom_rows.js";

import update from "immutability-helper";

export default (state = {}, action) => {
  switch (action.type) {

  case CE_OPEN_SAVE_CUSTOM_ROW_MODAL:
    return newModal(state, "save_custom_row", {
      name: action.bee_row_args.metadata ? action.bee_row_args.metadata.name : "",
      bee_row_args: action.bee_row_args,
    });

  case CE_DISMISS_SAVE_CUSTOM_ROW_MODAL:
    return closeModal(state);

  case CE_SAVE_CUSTOM_ROW_STARTED:
    return mergeModalState(state, {
      save_in_progress: true,
    });

  case CE_SAVE_CUSTOM_ROW_SUCCESS:
    return closeModal(state);

  case CE_SAVE_CUSTOM_ROW_ABORTED:
    return closeModal(state);

  case CE_SAVE_CUSTOM_ROW_FAILURE:
    return mergeModalState(state, {
      error_message: action.error_message,
      offer_overwrite: action.offer_overwrite,
      save_in_progress: false,
    });

  //- manage

  case CE_MANAGE_CUSTOM_ROWS_LOAD_STARTED:
    return newModal(state, "manage_custom_rows", {});

  case CE_MANAGE_CUSTOM_ROWS_LOAD_SUCCESS:
    return mergeModalState(state, {
      error_message: null,
      custom_rows: action.custom_rows,
    });

  case CE_MANAGE_CUSTOM_ROWS_LOAD_FAILURE:
    return mergeModalState(state, {
      error_message: action.error_message,
      custom_rows: null,
    });

  case CE_MANAGE_CUSTOM_ROWS_LOAD_ABORTED:
    return closeModal(state);

  //- delete

  case CE_DELETE_CUSTOM_ROW_REQUEST:
    return mergeModalState(state, {
      delete_row_id: action.row_id,
      delete_confirmed: false,
      rename_row_id: null,
      rename_row_name: null,
      error_message: null,
    });

  case CE_DELETE_CUSTOM_ROW_STARTED:
    return mergeModalState(state, {
      delete_row_id: action.row_id,
      delete_confirmed: true,
      delete_in_progress: true,
      error_message: null,
    });

  case CE_DELETE_CUSTOM_ROW_SUCCESS: {
    let customRows = state && state.modal && state.modal.state && state.modal.state.custom_rows;
    const index = customRows.findIndex((e) => e.id == action.row_id);

    if ( index >= 0 ) {
      customRows = update(customRows, { $splice: [ [ index, 1 ] ] });
    }

    return mergeModalState(state, {
      custom_rows: customRows,
      delete_in_progress: false,
      error_message: null,
    });
  }

  case CE_DELETE_CUSTOM_ROW_ABORTED:
    return mergeModalState(state, {
      delete_row_id: null,
      delete_confirmed: false,
      delete_in_progress: false,
      error_message: null,
    });

  case CE_DELETE_CUSTOM_ROW_FAILURE: {
    return mergeModalState(state, {
      delete_confirmed: false,
      delete_in_progress: false,
      error_message: action.error_message,
    });
  }

  //- rename

  case CE_RENAME_CUSTOM_ROW_REQUEST:
    return mergeModalState(state, {
      delete_row_id: null,
      delete_confirmed: false,
      rename_row_id: action.row_id,
      rename_row_name: action.row_name,
      rename_in_progress: false,
      error_message: null,
    });

  case CE_RENAME_CUSTOM_ROW_STARTED: {
    return mergeModalState(state, {
      rename_in_progress: true,
    });
  }

  case CE_RENAME_CUSTOM_ROW_SUCCESS: {
    let customRows = state && state.modal && state.modal.state && state.modal.state.custom_rows;
    const index = customRows.findIndex((e) => e.id == action.row_id);

    if ( index >= 0 ) {
      customRows = update(customRows, {
        [index]: { $merge: { name: action.row_name } },
      });
    }

    return mergeModalState(state, {
      rename_row_id: null,
      rename_row_name: null,
      rename_in_progress: false,
      custom_rows: customRows,
      error_message: null,
    });
  }

  case CE_RENAME_CUSTOM_ROW_FAILURE:
    return mergeModalState(state, {
      rename_in_progress: false,
      error_message: action.error_message,
    });

  case CE_RENAME_CUSTOM_ROW_ABORTED:
    return mergeModalState(state, {
      rename_row_id: null,
      rename_row_name: null,
      rename_in_progress: false,
      error_message: null,
    });

  default:
    return state;
  }
};
